<div class="print-block-container" fxLayout="row wrap">
  <div
    *ngIf="isSingle"
    class="full-width"
    fxLayout="row wrap"
    fxLayoutAlign="space-around center"
  >
    <shared-print-block-single
      (dataUpdate)="updateData($event)"
      [isSingle]="true"
      fxFlex="100"
      [placeholder]="instructionBlocks[0].placeholder"
      [limit]="instructionBlocks[0].limit"
      [type]="instructionBlocks[0].type"
    ></shared-print-block-single>
  </div>

  <div *ngIf="!isSingle" class="multiple-block" fxFlex="100">
    <div
      fxFlex="100"
      fxLayout="row wrap"
      fxLayoutAlign="space-between center"
      *ngFor="let block of instructionBlocks"
    >
      <shared-print-block-single
        fxFlex.lg="98"
        [placeholder]="block.placeholder"
        [limit]="block.limit"
        [type]="block.type"
        (dataUpdate)="updateData($event)"
      >
      </shared-print-block-single>
    </div>
  </div>
</div>
